import tools from '@/utils/tools';

//获取订单列表
const list = async function(params,that){
  var url = "/backend/Orders/list.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取订单列表
const get = async function(params,that){
  var url = "/backend/Orders/get.html"
  const res = await tools.post(url,params,that);
  return res
}

//保存订单列表
const save = async function(params,that){
  var url = "/backend/Orders/save.html"
  const res = await tools.post(url,params,that);
  return res
}

//接订单接口
const receive = async function(params,that){
  var url = "/backend/Orders/receive.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核订单接口
const examine = async function(params,that){
  var url = "/backend/Orders/examine.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const del = async function(params,that){
  var url = "/backend/Orders/del.html";
  const res = await tools.post(url,params,that);
  return res
}

//发货接口
const send = async function(params,that){
  var url = "/backend/Orders/send.html";
  const res = await tools.post(url,params,that);
  return res
}

//发货接口
const sendFinish = async function(params,that){
  var url = "/backend/Orders/sendFinish.html";
  const res = await tools.post(url,params,that);
  return res
}

//完成接口
const finish = async function(params,that){
  var url = "/backend/Orders/finish.html";
  const res = await tools.post(url,params,that);
  return res
}

//完成接口
const service = async function(params,that){
  var url = "/backend/Orders/service.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取需求列表
const demandlist = async function(params,that){
  var url = "/backend/Orders/demandlist.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取需求列表
const getalldemand = async function(params,that){
  var url = "/backend/Orders/getalldemand.html"
  const res = await tools.post(url,params,that);
  return res
}

//保存需求列表
const saveDemand = async function(params,that){
  var url = "/backend/Orders/saveDemand.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取需求接口
const getdemand = async function(params,that){
  var url = "/backend/Orders/getdemand.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核需求接口
const examineDemand = async function(params,that){
  var url = "/backend/Orders/examineDemand.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核需求接口
const examineDemandAll = async function(params,that){
  var url = "/backend/Orders/examineDemandAll.html";
  const res = await tools.post(url,params,that);
  return res
}

//下单
const makeOrder = async function(params,that){
  var url = "/backend/Orders/makeOrder.html";
  const res = await tools.post(url,params,that);
  return res
}

const makeAllOrder = async function(params,that){
  var url = "/backend/Orders/makeAllOrder.html";
  const res = await tools.post(url,params,that);
  return res
}
 
//确认下单
const sureOrder = async function(params,that){
  var url = "/backend/Orders/sureOrder.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const delDemand = async function(params,that){
  var url = "/backend/Orders/delDemand.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const importDemand = async function(params,that){
  var url = "/backend/Orders/importDemand.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const finishDemand = async function(params,that){
  var url = "/backend/Orders/finishDemand.html";
  const res = await tools.post(url,params,that);
  return res
}
//删除订单接口
const changeDemand = async function(params,that){
  var url = "/backend/Orders/changeDemand.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const exportOrder = async function(params,that){
  var url = "/backend/Orders/exportOrder.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const setDemandPrice = async function(params,that){
  var url = "/backend/Orders/setDemandPrice.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const examineDemandPrice = async function(params,that){
  var url = "/backend/Orders/examineDemandPrice.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const downPO = async function(params,that){
  var url = "/backend/Orders/downPO.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const downPOAll = async function(params,that){
  var url = "/backend/Orders/downPOAll.html";
  const res = await tools.post(url,params,that);
  return res
}
//删除订单接口
const finishAll = async function(params,that){
  var url = "/backend/Orders/finishAll.html";
  const res = await tools.post(url,params,that);
  return res
}
//删除订单接口
const polist = async function(params,that){
  var url = "/backend/Orders/poLists.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除订单接口
const exportDemand = async function(params,that){
  var url = "/backend/Orders/exportDemand.html";
  const res = await tools.post(url,params,that);
  return res
}

const setfile = async function(params,that){
  var url = "/backend/Orders/setfile.html";
  const res = await tools.post(url,params,that);
  return res
}

const sendAll = async function(params,that){
  var url = "/backend/Orders/sendAll.html";
  const res = await tools.post(url,params,that);
  return res
}

const delfile = async function(params,that){
  var url = "/backend/Orders/delfile.html";
  const res = await tools.post(url,params,that);
  return res
}

const delPOOrders = async function(params,that){
  var url = "/backend/Orders/delPOOrders.html";
  const res = await tools.post(url,params,that);
  return res
}

const orderFunction = {
  list,
  get,
  save,
  receive,
  examine,
  examineDemandAll,
  send,
  sendFinish,
  finish,
  service,
  exportOrder,
  del,
  saveDemand,
  changeDemand,
  demandlist,
  getdemand,
  examineDemand,
  importDemand,
  makeOrder,
  sureOrder,
  delDemand,
  finishDemand,
  setDemandPrice,
  examineDemandPrice,
  downPO,
  downPOAll,
  finishAll,
  polist,
  exportDemand,
  setfile,
  sendAll,
  delfile,
  delPOOrders,
  getalldemand,
  makeAllOrder,
}

export default orderFunction;


// WEBPACK FOOTER //
// ./src/api/order.js